import { all, call, put } from 'redux-saga/effects';
import getMobilityPlansSaga from './mobilityPlans.saga';
import UserClient from '../../api/UserClient';
import { setSubscriptions, setSubscriptionsFetching, userGetSuccessful } from '../../redux/user/actions';

export function* getUserSubscriptionsSaga(userProfile) {
    try {
        yield put(setSubscriptionsFetching(true));

        let newUserProfile;

        if (userProfile) {
            newUserProfile = userProfile;
        } else {
            newUserProfile = yield call(UserClient.getUserProfile);
        }

        const subscriptions = yield call(UserClient.getUserSubscriptions, newUserProfile.profileId);
        yield put(setSubscriptions(subscriptions));

        return newUserProfile;
    } catch (error) {
        console.error('[getUserSubscriptionsSaga]', error);
        return null;
    } finally {
        yield put(setSubscriptionsFetching(false));
    }
}

export default function* setupMobilityPlanPageSaga() {
    try {
        const [, user, userProfile] = yield all([
            call(getMobilityPlansSaga),
            call(UserClient.getUser),
            call(getUserSubscriptionsSaga),
        ]);

        yield put(
            userGetSuccessful({
                user: {
                    ...user,
                    profile: userProfile,
                },
            })
        );
    } catch (error) {
        console.error('[setupMobilityPlanPageSaga]', error);
    }
}
